import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import Link from "@material-ui/core/Link";
import React from "react";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: "auto",
    borderTop: "1px solid",
    borderColor: theme.palette.secondary.contrastText,
    padding: "38px 24px",
    opacity: 0.9,
  },
  button: { cursor: "pointer" },
  icon: { marginRight: theme.spacing(2) },
}));

function AppLink({ icon, text, clickHandle, href }) {
  const classes = useStyles();

  if (clickHandle) {
    return (
      <div className={classes.root}>
        <Link
          color="inherit"
          underline="none"
          className={classes.button}
          href={href}
          onClick={(event) => {
            event.preventDefault();
            clickHandle();
          }}
        >
          <Grid container alignItems="center">
            {icon && <Icon className={classes.icon}>{icon}</Icon>}
            <Typography variant="body2">{text}</Typography>
          </Grid>
        </Link>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Link
        color="inherit"
        underline="none"
        className={classes.button}
        href={href}
      >
        <Grid container alignItems="center">
          {icon && <Icon className={classes.icon}>{icon}</Icon>}
          <Typography variant="body2">{text}</Typography>
        </Grid>
      </Link>
    </div>
  );
}

export default AppLink;
